import { i as page } from './index2.js';
import 'tty';
import 'os';
import 'deepmerge';
import 'axios';
import 'vue';
import { n as normalizeComponent } from './normalize-component.js';
import { c as createInjector } from './browser.js';

//
var script = {
  mixins: [page],
  computed: {
    fontsizesMap: function fontsizesMap() {
      return {
        small: {
          name: this.$t('global.settingsFontSizeSmall'),
          value: 100
        },
        medium: {
          name: this.$t('global.settingsFontSizeMedium'),
          value: 150
        },
        large: {
          name: this.$t('global.settingsFontSizeLarge'),
          value: 200
        }
      };
    }
  },
  data: function data() {
    return {
      nCurrentFontsize: parseInt(this.$xp.clientsettings.getClientSetting('fontsize')),
      bShowOutlines: parseInt(this.$xp.clientsettings.getClientSetting('outlines'))
    };
  },
  methods: {
    changeFontSizeByName: function changeFontSizeByName(Name) {
      var newSize = this.getFontSizeForName(Name);
      console.log('changeFontSizeByName', Name, newSize);
      this.changeFontSize(newSize);
    },
    changeFontSize: function changeFontSize(NewValue) {
      if (NewValue >= 100 && NewValue <= 200) {
        this.$xp.clientsettings.saveClientSetting('fontsize', NewValue);
      } else {
        this.$xp.clientsettings.removeClientSetting('fontsize');
      }

      this.$xp.clientsettings.applyClientSettings();
    },
    changeOutlines: function changeOutlines(NewValue) {
      if (NewValue) {
        this.$xp.clientsettings.saveClientSetting('outlines', 1);
      } else {
        this.$xp.clientsettings.removeClientSetting('outlines');
      }

      this.$xp.clientsettings.applyClientSettings();
    },
    getFontSizeNames: function getFontSizeNames() {
      var _this = this;

      return Object.keys(this.fontsizesMap).map(function (key) {
        return _this.fontsizesMap[key].name;
      });
    },
    getFontSizeForName: function getFontSizeForName(Name) {
      var _this2 = this;

      var result = NaN;
      Object.keys(this.fontsizesMap).forEach(function (element) {
        console.log('element', element, Name);

        if (_this2.fontsizesMap[element].name === Name) {
          console.log('found element', element, Name, _this2.fontsizesMap[element].value);
          result = _this2.fontsizesMap[element].value;
        }
      });
      return result;
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "c-client-settings-page" }, [
    this.$xp.clientsettings.available.includes("fontsize")
      ? _c("div", { staticClass: "client-setting" }, [
          _c("h2", { staticClass: "client-setting-heading" }, [
            _vm._v(_vm._s(_vm.$t("global.settingsFontsizeTitle")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "client-setting-description" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("global.settingsFontsizeDescr")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "client-setting-options" }, [
            _c(
              "form",
              _vm._l(_vm.getFontSizeNames(), function(sizeLocaleName) {
                return _c("div", { key: sizeLocaleName }, [
                  _c("input", {
                    attrs: {
                      id: "setfontsize" + sizeLocaleName,
                      name: "setfontsize",
                      type: "radio"
                    },
                    domProps: {
                      value: sizeLocaleName,
                      checked:
                        (!_vm.nCurrentFontsize &&
                          _vm.getFontSizeForName(sizeLocaleName) === 100) ||
                        _vm.getFontSizeForName(sizeLocaleName) ===
                          _vm.nCurrentFontsize
                    },
                    on: {
                      change: function($event) {
                        $event.preventDefault();
                        return _vm.changeFontSizeByName(sizeLocaleName)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { attrs: { for: "setfontsize" + sizeLocaleName } },
                    [_vm._v(_vm._s(sizeLocaleName))]
                  )
                ])
              }),
              0
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    this.$xp.clientsettings.available.includes("outlines")
      ? _c("div", { staticClass: "client-setting" }, [
          _c("h2", { staticClass: "client-setting-heading" }, [
            _vm._v(_vm._s(_vm.$t("global.settingsOutlinesTitle")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "client-setting-description" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("global.settingsOutlinesDescr")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "client-setting-options" }, [
            _c("form", [
              _c("div", [
                _c("input", {
                  attrs: {
                    id: "setoutline-off",
                    name: "setfontsize",
                    type: "radio"
                  },
                  domProps: { value: 0, checked: !_vm.bShowOutlines },
                  on: {
                    change: function($event) {
                      $event.preventDefault();
                      return _vm.changeOutlines(0)
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "setoutline-off" } }, [
                  _vm._v(_vm._s(_vm.$t("global.off")))
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  attrs: {
                    id: "setoutline-on",
                    name: "setfontsize",
                    type: "radio"
                  },
                  domProps: { value: 1, checked: _vm.bShowOutlines },
                  on: {
                    change: function($event) {
                      $event.preventDefault();
                      return _vm.changeOutlines(1)
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "setoutline-on" } }, [
                  _vm._v(_vm._s(_vm.$t("global.on")))
                ])
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-3234fd7e_0", { source: "\n.client-setting {\n  margin-bottom: 2em;\n}\n.client-setting-heading {\n  margin: 0 0 3px 0;\n}\n", map: {"version":3,"sources":["/Users/alali/projects/core-4/src/components/pages/XpClientSettingsPage.vue"],"names":[],"mappings":";AAwGA;EACA,kBAAA;AACA;AAEA;EACA,iBAAA;AACA","file":"XpClientSettingsPage.vue","sourcesContent":["<template>\n    <div class=\"c-client-settings-page\">\n      <div v-if=\"this.$xp.clientsettings.available.includes('fontsize')\" class=\"client-setting\">\n        <h2 class=\"client-setting-heading\">{{ $t('global.settingsFontsizeTitle') }}</h2>\n        <div class=\"client-setting-description\">\n          {{ $t('global.settingsFontsizeDescr') }}\n        </div>\n        <div class=\"client-setting-options\">\n          <form>\n            <div v-for=\"sizeLocaleName in getFontSizeNames()\" :key=\"sizeLocaleName\">\n              <input v-bind:id=\"'setfontsize' + sizeLocaleName\" name=\"setfontsize\" :value=sizeLocaleName @change.prevent=\"changeFontSizeByName(sizeLocaleName)\" :checked=\"(!nCurrentFontsize && getFontSizeForName(sizeLocaleName) === 100) || getFontSizeForName(sizeLocaleName) === nCurrentFontsize\" type=\"radio\"/> <label v-bind:for=\"'setfontsize' + sizeLocaleName\">{{ sizeLocaleName }}</label>\n            </div>\n          </form>\n        </div>\n      </div>\n      <div v-if=\"this.$xp.clientsettings.available.includes('outlines')\" class=\"client-setting\">\n        <h2 class=\"client-setting-heading\">{{ $t('global.settingsOutlinesTitle') }}</h2>\n        <div class=\"client-setting-description\">\n          {{ $t('global.settingsOutlinesDescr') }}\n        </div>\n        <div class=\"client-setting-options\">\n          <form>\n            <div>\n              <input id=\"setoutline-off\" name=\"setfontsize\" :value=0 @change.prevent=\"changeOutlines(0)\" :checked=\"!bShowOutlines\" type=\"radio\"/> <label for=\"setoutline-off\">{{ $t('global.off') }}</label>\n            </div>\n            <div>\n              <input id=\"setoutline-on\" name=\"setfontsize\" :value=1 @change.prevent=\"changeOutlines(1)\" :checked=\"bShowOutlines\" type=\"radio\"/> <label for=\"setoutline-on\">{{ $t('global.on') }}</label>\n            </div>\n          </form>\n        </div>\n      </div>\n    </div>\n</template>\n\n<script>\nimport pageMixin from '../../mixins/page'\n\nexport default {\n  mixins: [pageMixin],\n  computed: {\n    fontsizesMap () {\n      return {\n        small: {\n          name: this.$t('global.settingsFontSizeSmall'),\n          value: 100\n        },\n        medium: {\n          name: this.$t('global.settingsFontSizeMedium'),\n          value: 150\n        },\n        large: {\n          name: this.$t('global.settingsFontSizeLarge'),\n          value: 200\n        }\n      }\n    }\n  },\n  data () {\n    return {\n      nCurrentFontsize: parseInt(this.$xp.clientsettings.getClientSetting('fontsize')),\n      bShowOutlines: parseInt(this.$xp.clientsettings.getClientSetting('outlines'))\n    }\n  },\n  methods: {\n    changeFontSizeByName (Name) {\n      const newSize = this.getFontSizeForName(Name)\n      console.log('changeFontSizeByName', Name, newSize)\n      this.changeFontSize(newSize)\n    },\n    changeFontSize (NewValue) {\n      if (NewValue >= 100 && NewValue <= 200) {\n        this.$xp.clientsettings.saveClientSetting('fontsize', NewValue)\n      } else {\n        this.$xp.clientsettings.removeClientSetting('fontsize')\n      }\n      this.$xp.clientsettings.applyClientSettings()\n    },\n    changeOutlines (NewValue) {\n      if (NewValue) {\n        this.$xp.clientsettings.saveClientSetting('outlines', 1)\n      } else {\n        this.$xp.clientsettings.removeClientSetting('outlines')\n      }\n      this.$xp.clientsettings.applyClientSettings()\n    },\n    getFontSizeNames () {\n      return Object.keys(this.fontsizesMap).map(key => this.fontsizesMap[key].name)\n    },\n    getFontSizeForName (Name) {\n      let result = NaN\n      Object.keys(this.fontsizesMap).forEach(element => {\n        console.log('element', element, Name)\n        if (this.fontsizesMap[element].name === Name) {\n          console.log('found element', element, Name, this.fontsizesMap[element].value)\n          result = this.fontsizesMap[element].value\n        }\n      })\n      return result\n    }\n\n  }\n}\n</script>\n<style>\n  .client-setting {\n    margin-bottom: 2em;\n  }\n\n  .client-setting-heading {\n    margin: 0 0 3px 0;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
//# sourceMappingURL=XpClientSettingsPage.js.map
